import { useCallback } from 'react';
import { ViewStateChangeEvent, MapLayerMouseEvent } from 'react-map-gl';
import type { GeoJSONSource } from 'react-map-gl';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';

import { useUserCoordinates } from '../../job-explorer.hooks';
import {
  isRestaurantsExplorerAtom,
  explorerRestaurantZoomLevelAtom,
} from '../../job-explorer-restaurant-explorer.atoms';
import { getMapRefAtom, setZoomLevelAtom } from '../../job-explorer-map.atoms';
import { useMapRedirection } from '../job-explorer-map.hooks/use-map-redirection';

export const useJobExplorerMap = () => {
  const mapRef = useAtomValue(getMapRefAtom);
  const setZoomLevel = useSetAtom(setZoomLevelAtom);
  const [isRestaurantsExplorer] = useAtom(isRestaurantsExplorerAtom);
  const setExplorerRestaurantZoomLevel = useSetAtom(explorerRestaurantZoomLevelAtom);
  useUserCoordinates({ map: mapRef?.current });
  useMapRedirection();
  const handleZoomEndCb = useCallback(
    (e: ViewStateChangeEvent) => {
      if (isRestaurantsExplorer) {
        setExplorerRestaurantZoomLevel(e.viewState.zoom);
        return;
      }
      setZoomLevel(e.viewState.zoom);
    },
    [isRestaurantsExplorer, setExplorerRestaurantZoomLevel, setZoomLevel]
  );

  const onClick = useCallback(
    (event: MapLayerMouseEvent) => {
      const feature = event?.features?.[0] as any;

      const clusterId = feature?.properties?.['cluster_id'];

      const mapboxSource = mapRef.current?.getSource('job-positions') as GeoJSONSource;

      mapboxSource?.getClusterExpansionZoom(clusterId, (err, zoom) => {
        if (err) return;
        const coordinates = feature?.['geometry']?.['coordinates'];
        if (coordinates?.length)
          mapRef.current?.easeTo({
            center: coordinates,
            zoom,
            duration: 500,
          });
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [mapRef?.current]
  );
  return {
    handleZoomEndCb,
    onClick,
  };
};
